<template>
<v-dialog v-model="value.show" max-width="500px">
  <v-card>
    <v-card-title primary-title v-text="title" />
    <v-card-text>
      <v-text-field
        name='password'
        :label='$t("user.new_password")'
        :hint="$t('user.password_rules')" persistent-hint
        :type="showPassword ? 'text' : 'password'"
        :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'" @click:append="showPassword = !showPassword"
        append-outer-icon="mdi-key-plus" @click:append-outer="password = randomPassword(12, passwordComplexityRules)"
        :rules="passwordComplexityRules(password)"
        v-model='password'
        @keyup="change"
      />
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
        <v-btn color="primary" @click="save" :disabled="btnDisabled" v-text="$t('button.save')" />
        <v-btn color='blue darken-1' text @click.stop="closeModal()" v-text="$t('button.close')" />
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
import Servico from '@/services/UserService'
import LocalStorageService from '@/services/LocalStorageService'
import { passwordComplexityRules } from '@/utils/rules'
import randomPassword from '@/utils/RandomPassword'

export default {
  data: function () {
    return {
      password: '',
      btnDisabled: true,
      showPassword: false,
      passwordComplexityRules,
      randomPassword
    }
  },

  props: {
    value: Object
  },

  computed: {
    title () { return `${this.$t('user.change_password_of')} ${this.value.username}` }
  },

  methods: {
    change () {
      this.btnDisabled = this.password.length === 0
    },
    save () {
      Servico.updatePassword(LocalStorageService.getClientPrefix(), this.$props.value.username, this.password).then((response) => {
        this.value.show = false
        this.password = ''
      })
    },
    closeModal () {
      this.value.show = false
      this.password = ''
    }
  }
}
</script>
